// extracted by mini-css-extract-plugin
export var container = "ShareModal-module_container__32Ri6";